import { ListingCard, ListingRow } from './ListingCard';
import { STAGE_META, dayDate, dayLabel } from '../../lib/workflow';

const StageSummary = ({ items }) => {
  const counts = items.reduce((m, p) => (p.stage ? { ...m, [p.stage]: (m[p.stage] || 0) + 1 } : m), {});
  return (
    <div className="hidden md:flex items-center gap-2">
      {Object.entries(counts).map(([s, n]) => (
        <span key={s} className="text-[11px] font-semibold text-[#6E635B]" title={STAGE_META[s]?.label}>{STAGE_META[s]?.emoji} {n}</span>
      ))}
    </div>
  );
};

export const DayGroup = ({ dayKey, items, view, selected, onToggle, onSelectDay, onOpen, onDelete }) => {
  const allSelected = items.every((p) => selected.has(p.id));
  return (
    <section className="space-y-3" data-testid={`etsy-day-group-${dayKey}`}>
      <div className="sticky top-16 md:top-0 z-10 -mx-2 px-2 py-2 bg-[#FAF7F2]/90 backdrop-blur-md flex items-center gap-3">
        <h2 className="font-jakarta text-base font-bold text-[#2D2623]" data-testid={`etsy-day-label-${dayKey}`}>
          📅 {dayLabel(dayKey)} <span className="text-[#9A8E85] font-semibold text-sm">· {dayDate(dayKey)}</span>
        </h2>
        <span className="rounded-full bg-[#2D2623] text-white text-[11px] font-bold px-2.5 py-0.5" data-testid={`etsy-day-count-${dayKey}`}>
          {items.length} listing{items.length === 1 ? '' : 's'}
        </span>
        <StageSummary items={items} />
        <button onClick={() => onSelectDay(items, !allSelected)} className="ml-auto text-[11px] font-semibold text-[#C85A32] hover:underline" data-testid={`etsy-select-day-${dayKey}`}>
          {allSelected ? 'Unselect day' : 'Select day'}
        </button>
      </div>
      {view === 'grid' ? (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {items.map((p, i) => (
            <ListingCard key={p.id} p={p} index={i} selected={selected.has(p.id)} onToggle={onToggle} onOpen={onOpen} onDelete={onDelete} />
          ))}
        </div>
      ) : (
        <div className="wf-card rounded-2xl divide-y divide-[#F0EAE1] overflow-hidden">
          {items.map((p) => (
            <ListingRow key={p.id} p={p} selected={selected.has(p.id)} onToggle={onToggle} onOpen={onOpen} onDelete={onDelete} />
          ))}
        </div>
      )}
    </section>
  );
};
